import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import {
  AiOutlineUser,
  AiOutlineMail
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";
import { MdWork } from "react-icons/md";
import { FaTools } from "react-icons/fa";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    updateExpanded(false);
  };

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <h1 className="heading">
          <strong className="main-name">BS</strong>
        </h1>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#about">
            <Nav.Item>
              <Nav.Link onClick={() => scrollToSection('about')} style={{ cursor: 'pointer' }}>
                <AiOutlineUser style={{ marginBottom: "2px", marginRight: "0.5rem" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollToSection('work')} style={{ cursor: 'pointer' }}>
                <MdWork style={{ marginBottom: "2px", marginRight: "0.5rem" }} /> Work
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollToSection('skills')} style={{ cursor: 'pointer' }}>
                <FaTools style={{ marginBottom: "2px", marginRight: "0.5rem" }} /> Skills
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link onClick={() => scrollToSection('contact')} style={{ cursor: 'pointer' }}>
                <AiOutlineMail style={{ marginBottom: "2px", marginRight: "0.5rem" }} /> Contact
              </Nav.Link>
            </Nav.Item>
          </Nav>
          
          <Nav className="ms-2">
            <Nav.Item>
              <Nav.Link
                href="/Resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="resume-btn"
                style={{ cursor: 'pointer' }}
              >
                <CgFileDocument style={{ marginBottom: "2px", marginRight: "0.5rem" }} /> Resume
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;